import React, { useState } from "react";
import {
    ResponsiveContainer,
    BarChart,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    Bar,
} from "recharts";

export default function DemoWeeklyEnergyChart() {
    const data = [
        { date: "2023-10-23", dailyImport: 120.5, dailyExport: 5.2 },
        { date: "2023-10-24", dailyImport: 135.0, dailyExport: 4.8 },
        { date: "2023-10-25", dailyImport: 110.8, dailyExport: 6.1 },
        { date: "2023-10-26", dailyImport: 145.2, dailyExport: 3.5 },
        { date: "2023-10-27", dailyImport: 130.4, dailyExport: 4.0 },
        { date: "2023-10-28", dailyImport: 125.7, dailyExport: 5.5 },
        { date: "2023-10-29", dailyImport: 140.1, dailyExport: 4.2 },
    ];

    return (
        <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-5">
            <h3 className="text-sm font-semibold text-slate-700 mb-3">
                Son 7 Günlük Aktif Enerji Tüketimi (kWh)
            </h3>

            <div className="h-80">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={data}>
                        <XAxis dataKey="date" stroke="#6B7280" />
                        <YAxis stroke="#6B7280" />
                        <Tooltip />
                        <Legend />
                        <Bar dataKey="dailyImport" name="Import (kWh)" fill="#10B981" />
                        <Bar dataKey="dailyExport" name="Export (kWh)" fill="#F59E0B" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
